import { webLog } from '../plugin/webLog'
import { getCookie } from './utils'

document.addEventListener(
  'error',
  function (e) {
    console.log(e)
    try {
      if (e.target && e.target.tagName == 'SCRIPT') {
        var is_vendors = e.target.src.indexOf('chunk-vendors') > 0
        var COUNT_KEY = 'LIVEPAGE_REFRESH_COUNT'
        var count = +sessionStorage.getItem(COUNT_KEY)
        var data = {
          url: location.href,
          title: is_vendors ? '加载vendors失败' : '加载js失败',
          src: e.target.src,
          time: new Date().toLocaleString(),
          cookie: getCookie('zbvz_userid'),
        }
        webLog(data)
        if (is_vendors) {
          if (Number.isInteger(count) && count <= 3) {
            sessionStorage.setItem(COUNT_KEY, count + 1)
            setTimeout(function () {
              location.reload(true)
            }, 800)
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  },
  true
)
